import { Box, Tag, TagColor, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import i18n from 'modules/core/lib/i18n'

interface PaymentOverviewCardProps {
  statusLabel: string
  statusColor: TagColor
  amountLabel: string
  amountValue: string | number
  countLabel: string
  countValue: string | number
  totalEmployees?: number
}

const PaymentOverviewCard = ({
  statusLabel,
  statusColor,
  amountLabel,
  amountValue,
  countLabel,
  countValue,
  totalEmployees,
}: PaymentOverviewCardProps) => {
  const countStr =
    countValue == '—' || !!totalEmployees === false
      ? countValue
      : `${countValue} / ${totalEmployees}`

  return (
    <Box
      border={{ all: { color: 'grey400', style: 'solid', width: 's1' } }}
      borderRadius={{ all: 'abs008' }}
      flexDirection="column"
      padding="s24"
      gap="s24"
      width="s300"
      justifyContent="spaceAround"
      alignItems="flexStart"
      flexGrow
      className={`payroll-overview-stats payroll-overview-stats--${statusLabel.toLowerCase()}`}
    >
      <Box alignSelf="flexStart">
        <Tag type={statusColor}>{statusLabel}</Tag>
      </Box>
      <Box flexDirection="row" width="full">
        <Box flexDirection="column" flexGrow style={{ flexBasis: '0' }}>
          <Text.Normal color="grey800" size="100">
            {amountLabel}
          </Text.Normal>
          <Text.Header2>{amountValue}</Text.Header2>
        </Box>
        <Box flexDirection="column" flexGrow style={{ flexBasis: '0' }}>
          <Text.Normal color="grey800" size="100">
            {countLabel}
          </Text.Normal>
          <Box flexDirection="row" alignItems="center">
            <Text.Header2>{countStr}</Text.Header2>
            {countStr != '—' && !!totalEmployees && totalEmployees !== countValue && (
              <>
                <div>&nbsp;</div>
                <InformationTooltip
                  information={i18n.t(
                    'payroll_bundle.results_payments.results.summary.number_of_employees_pending_to_pay',
                    { number: totalEmployees - Number(countValue) }
                  )}
                  icon="alert"
                />
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default observer(PaymentOverviewCard)
